import React, { useState } from "react";
import "../Navbar/Navbar.css";
import { FaHome } from "react-icons/fa";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdContactMail } from "react-icons/md";
import { GiSkills } from "react-icons/gi";
import { FaPersonBiking } from "react-icons/fa6";

function Navbar() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const navbarDetails = [
    {
      name: <FaHome className="icon" />,
      hoverd: "Home",
      targetId: "header",
    },
    {
      name: <BsInfoCircleFill className="icon" />,
      hoverd: "About",
      targetId: "about",
    },
    {
      name: <GiSkills className="icon" />,
      hoverd: "Skills",
      targetId: "skills",
    },
    {
      name: <FaPersonBiking className="icon" />,
      hoverd: "Hobby",
      targetId: "hobbies",
    },
    {
      name: <MdContactMail className="icon" />,
      hoverd: "Contact",
      targetId: "footer",
    },
  ];

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="navbar-container">
      {navbarDetails.map((button, index) => (
        <div
          key={index}
          className="navlink"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
          onClick={() => scrollToSection(button.targetId)}
        >
          <div className="button">
            {hoveredIndex === index ? button.hoverd : button.name}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Navbar;
